import { render, staticRenderFns } from "./questiondetail.vue?vue&type=template&id=680c9479&scoped=true"
import script from "./questiondetail.vue?vue&type=script&lang=js"
export * from "./questiondetail.vue?vue&type=script&lang=js"
import style0 from "./questiondetail.vue?vue&type=style&index=0&id=680c9479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c9479",
  null
  
)

export default component.exports